import { BCMSDate, BCMSStateManagerCRUD, useModel } from "@bcm-dev/bcms-vite";
import ChatPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/ChatPage";
import ChatItem from "components/pages/ChatPage/classes/ChatItem";

export default function CaptureChatAgentResponse(props) {
    const { branding } = useModel();
    const options = branding.options || {};

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI(options))
        .update([ "showInitialMessage" ], false)
        .update([ "showTranslationPopup" ], false)
        .submit();

    const date = BCMSDate.init();
    const response = ChatItem.init("Hi, there! How can I help you?", "received", date, 0)

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "messages" ], [ response ])
        .submit();

    return <ChatPage ui={ ui } data={ data } />
}